var exports = {
  "iE": "xaee3c4fa--0a8855--wrapper",
  "bs": "xaee3c4fa--0a8855--subscribed-message",
  "DD": "xaee3c4fa--0a8855--title",
  "Zd": "xaee3c4fa--0a8855--form",
  "SI": "xaee3c4fa--0a8855--form-title",
  "z3": "xaee3c4fa--0a8855--error",
  "fy": "xaee3c4fa--0a8855--consent-text",
  "ye": "xaee3c4fa--0a8855--consent-link",
  "nl": "xaee3c4fa--0a8855--input-wrapper",
  "A1": "xaee3c4fa--0a8855--_active",
  "fb": "xaee3c4fa--0a8855--form-wrapper",
  "P7": "xaee3c4fa--0a8855--inner-wrapper",
};

module.exports = exports;
